/* eslint react/no-danger : 0 */
import React from 'react'
import PropTypes from 'prop-types'
import useIsHydrated from './Hooks/useIsHydrated'

function Timestamp({ data }) {
  const isHydrated = useIsHydrated()
  // Returns null on first render, so the client and server match
  if (!isHydrated) return null
  if (!data) return null

  const timestamp = data
  const delta = (Date.now() - timestamp) / 1000
  const days = Math.floor(delta / 86400)
  const hours = Math.floor((delta % 86400) / 3600)
  const minutes = Math.floor((delta % 3600) / 60)
  const arr = []

  if (days) arr.push(`${days}d`)
  if (hours) arr.push(`${hours}h`)
  if (minutes) arr.push(`${minutes}m`)
  return <span className="timestamp">{`Deployed: ${arr.join(' ')} ago`}</span>
}

Timestamp.defaultProps = {
  data: null
}

Timestamp.propTypes = {
  data: PropTypes.number
}

export default Timestamp
